import { useStaticQuery, graphql } from 'gatsby';

export interface GrammarPointsQueryResult {
  mongodb_id: string;
  title: string;
  translation: {
    en: string;
  };
  tags: string[];
  cases: GrammarPointCase[];
}

export interface GrammarPointCase {
  subtitle: string;
  sentences: string[];
  explanation: string;
  structure: string;
}

export const useGrammarPoints = () => {
  const { grammarPoints } = useStaticQuery(
    graphql`
      query GrammarPointsQuery {
        grammarPoints: allMongodbChineseGrammarPoints {
          nodes {
            mongodb_id
            tags
            title
            translation {
              en
            }
            cases {
              explanation
              sentences
              structure
              subtitle
            }
          }
        }
      }
    `
  );
  return grammarPoints;
};
